export enum PromoCodeType {
  Group = 'Group',
  Agent = 'Agent',
  General = 'General',
  Corporation = 'Corporation',
}
